<template>
  <div>
    <v-btn icon @click="ativarDialog" title="Visualizar Lista de Produtos do Pedido">
      <v-icon>mdi-file-document-outline</v-icon>
    </v-btn>

    <sys-dialog-fullscreen v-model="dialogAtivo">
      <template v-slot:titulo>
        <titulo-lista-produtos-do-pedido
          v-model="dialogAtivo"
          :pedido="pedido"
        />
      </template>

      <v-data-table
        id="data-table-produtos-do-pedido-de-separacao-robo"
        :headers="headers"
        :items="items"
        :search="pesquisa"
        height="calc(100vh - 160px)"
        class="table-full-screen mx-1 mt-1"
        :items-per-page="-1"
        fixed-header
        dense
      >
        <template v-slot:top>
          <div class="d-flex mt-1 mb-2">
            <p class="ma-0 mt-1 subtitle-1 font-weight-medium">
              <v-icon left>mdi-format-list-bulleted</v-icon>
              Listagem dos Produtos
            </p>

            <v-spacer />

            <v-text-field
              v-model="pesquisa"
              label="Pesquisa"
              hide-details
              height="28"
              append-icon="mdi-magnify"
              class="mt-n1"
              clearable
              style="max-width: 450px"
            ></v-text-field>
          </div>
        </template>

        <template v-slot:item.filial_destino="{item}">
          {{ item.descricao_hub ? item.descricao_hub : item.filial_destino }}
        </template>

        <template v-slot:item.qtde_pedido="{item}">
          {{Helpers.formatarValor(item.qtde_pedido)}}
        </template>

        <template v-slot:item.fator_conversao="{item}">
          {{Helpers.formatarValor(item.fator_conversao)}}
        </template>

        <template v-slot:item.qtde_pedido_pela_embalagem="{item}">
          {{Helpers.formatarValor(item.qtde_pedido / item.multiplo_compra)}}
        </template>
      </v-data-table>
    </sys-dialog-fullscreen>
  </div>
</template>

<script>
import SysDialogFullscreen from "../../../padraoDeLayout/SysDialogFullScreen";
import PedidoAPI from "../../../../api/drp/pedido"
import TituloListaProdutosDoPedido from "./TituloListaProdutosDoPedido";
import {logout} from "@/helpers";

export default {
  name: "ListaProdutosDoPedido",
  components: {TituloListaProdutosDoPedido, SysDialogFullscreen},
  props: {
    pedido: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    dialogAtivo: false,
    headers: [
      {text: 'Filial de Origem', value: 'filial_origem', width: '70px'},
      {text: 'Filial de Destino', value: 'filial_destino', width: '70px'},
      {text: 'Fabricante', value: 'idfornecedor'},
      {text: 'Cód. Fornecedor', value: 'cod_produto'},
      {text: 'Id Produto', value: 'idproduto'},
      {text: 'Descrição Produto', value: 'descricao_produto'},
      {text: 'Depósito Origem', value: 'dep_orig', width: '70px'},
      {text: 'Depósito Destino', value: 'dep_dest', width: '70px'},
      {text: 'Marca', value: 'marca'},
      {text: 'Embalagem', value: 'embalagem'},
      {text: 'Fator de Conversão', value: 'fator_conversao'},
      {text: 'Qtde. do Pedido', value: 'qtde_pedido'},
      {text: 'Qtde. de Embalagem', value: 'qtde_pedido_pela_embalagem'},
    ],
    items: [],
    pesquisa: ''
  }),
  methods: {
    ativarDialog() {
      this.dialogAtivo = ! this.dialogAtivo

      if (this.items.length === 0) {
        this.getProdutosDoPedido();
      }
    },
    getProdutosDoPedido(){
      this.$store.dispatch(
        "loading/addRequisicao",
        PedidoAPI.getProdutosDoPedidoSeparacao({pedido: this.pedido.idpedido})
          .then(response => {
            const {token, produtos} = response.data;
            localStorage.token = token;
            this.items = produtos;
          })
          .catch(logout)
      );
    },
  }
}
</script>

<style>
#data-table-produtos-do-pedido-de-separacao-robo .v-data-table__wrapper table tbody tr td  {
  font-size: 12px;
  padding: 1px 5px 1px 5px;
}
#data-table-produtos-do-pedido-de-separacao-robo .v-data-table__wrapper table thead tr th  {
  font-size: 12px;
  padding: 0 4px 0 4px;
}
</style>
